import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {baseUrl, userLocation} from "../Univ.js";
function VaccinationCertificatePrint() {
    const {id} = useParams();
    const [certificate, setCertificate] = useState(null);
    const [hospData, setHospData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const loadData = async () => {
            try {
                /* =====================================================
                   CERTIFICATE
                ===================================================== */
                const certificateResponse =
                    await axios.get(
                        `${baseUrl}vaccination/certificates/${id}/`
                    );
                setCertificate(
                    certificateResponse.data
                );
                /* =====================================================
                   HOSPITAL
                ===================================================== */
                const hospitalResponse =
                    await axios.get(
                        `${baseUrl}view-hospital/${userLocation}/`
                    );
                setHospData(
                    hospitalResponse.data
                );
            } catch (error) {
                console.error(
                    "Certificate loading error:",
                    error
                );
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, [id]);
    /* =============================================================
       PRINT
    ============================================================= */
    const handlePrint = () => {
        const printContents =
            document.getElementById(
                "vaccination-certificate-print"
            ).innerHTML;
        const originalContents =
            document.body.innerHTML;
        document.body.innerHTML =
            printContents;
        window.print();
        setTimeout(() => {
            document.body.innerHTML =
                originalContents;
            window.location.reload();
        }, 1000);
    };
    if (loading) {
        return (
            <div className="text-center p-5">
                Loading certificate...
            </div>
        );
    }
    if (!certificate) {
        return (
            <div className="text-center p-5">
                Certificate not found.
            </div>
        );
    }
    return (
        <section className="container-fluid">

            <div
                id="vaccination-certificate-print"
                className="p-4"
            >

                {/* =================================================
                    HOSPITAL HEADER
                ================================================= */}

                {hospData.map((hospital) => (
                    <div
                        key={hospital.id}
                        className="text-center mb-4"
                        style={{
                            borderBottom: "2px solid #000",
                            paddingBottom: "15px"
                        }}
                    >

                        <img
                            src={hospital.logo}
                            alt="Hospital Logo"
                            style={{
                                width: "70px",
                                height: "70px",
                                objectFit: "contain"
                            }}
                        />

                        <h3 className="mb-1">
                            {hospital.hospital}
                        </h3>

                        <div>
                            {hospital.address}
                        </div>

                        <div>
                            Phone : {hospital.mobile}
                            &nbsp;&nbsp;
                            Email : {hospital.email}
                        </div>

                        <div>
                            Web : {hospital.website}
                        </div>

                    </div>
                ))}


                {/* =================================================
                    CERTIFICATE TITLE
                ================================================= */}

                <div className="text-center mb-4">

                    <h2>
                        VACCINATION CERTIFICATE
                    </h2>

                    <strong>
                        Certificate No :
                        &nbsp;
                        {certificate.certificate_number}
                    </strong>

                </div>


                {/* =================================================
                    PATIENT INFORMATION
                ================================================= */}

                <table
                    width="100%"
                    cellPadding="8"
                    style={{
                        borderCollapse: "collapse",
                        marginBottom: "25px"
                    }}
                >

                    <tbody>

                    <tr>

                        <th
                            width="25%"
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            Patient Name
                        </th>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.patient?.patient ||
                                certificate.patient?.name ||
                                "-"}
                        </td>

                    </tr>


                    <tr>

                        <th
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            Patient ID
                        </th>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.patient?.pat_id ||
                                "-"}
                        </td>

                    </tr>


                    <tr>

                        <th
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            ABHA
                        </th>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.patient?.abha ||
                                "-"}
                        </td>

                    </tr>

                    </tbody>

                </table>


                {/* =================================================
                    VACCINATION INFORMATION
                ================================================= */}

                <table
                    width="100%"
                    cellPadding="8"
                    style={{
                        borderCollapse: "collapse"
                    }}
                >

                    <thead>

                    <tr
                        style={{
                            backgroundColor: "#1bc5ce",
                            color: "#fff"
                        }}
                    >

                        <th
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            Vaccine
                        </th>

                        <th
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            Dose
                        </th>

                        <th
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            Date
                        </th>

                        <th
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            Batch / Lot
                        </th>

                        <th
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            Administered By
                        </th>

                    </tr>

                    </thead>


                    <tbody>

                    <tr>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.vaccine?.vaccine_name ||
                                "-"}
                        </td>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.dose_number ||
                                "-"}
                        </td>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.certificate_date ||
                                certificate.add_date ||
                                "-"}
                        </td>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.batch_number ||
                                "-"}
                        </td>

                        <td
                            style={{
                                border: "1px solid #000"
                            }}
                        >
                            {certificate.administered_by ||
                                "-"}
                        </td>

                    </tr>

                    </tbody>

                </table>


                {/* =================================================
                    FOOTER
                ================================================= */}

                <div
                    className="row mt-5"
                >

                    <div className="col-md-6">

                        <p>
                            <strong>
                                Certificate Status:
                            </strong>
                            &nbsp;
                            {certificate.status || "VALID"}
                        </p>

                    </div>


                    <div className="col-md-6 text-end">

                        <br/>

                        <div
                            style={{
                                width: "200px",
                                marginLeft: "auto",
                                borderTop: "2px solid #000",
                                paddingTop: "5px"
                            }}
                        >
                            Authorized Signatory
                        </div>

                    </div>

                </div>

            </div>


            {/* =====================================================
                PRINT BUTTON
            ===================================================== */}

            <div
                className="d-flex justify-content-center mt-4 mb-4"
            >

                <button
                    type="button"
                    className="btn btn-primary px-5"
                    onClick={handlePrint}
                >
                    <i className="fa fa-print me-2"></i>
                    Print Certificate
                </button>

            </div>

        </section>
    );
}
export default VaccinationCertificatePrint;